import { FilterItems } from './filter-items';
import { Role } from './role';
import { FilterViewModel } from '../regulation';
import { MenuItemModel } from '../analytics/menu-item-model';

export class UserFilterModel {
  roleId: number;
  userId: number;
  externalUserId: string;

  constructor() {
    this.roleId = 0;
    this.userId = 0;
    this.externalUserId = '';
  }
}

export class UserDetailModel {
  role: Role;
  libraryMenu: MenuItemModel[];
  userJurisdiction: FilterViewModel[];

  constructor() {
    this.role = new Role();
    this.libraryMenu = [];
    this.userJurisdiction = [];
  }
}

export class UserInfoFilterModel {
  division: Array<string>;
  filters: FilterItems;

  constructor() {
    this.division = [];
    this.filters = new FilterItems();
  }
}
